import { I14V2VREGUL_State } from '@batical/types/src'

const I14V2VREGUL: I14V2VREGUL_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  in_kvVanne: 0.0,
  in_debitCircuit: 0.0,
  perteCharg_uuid: '6D91E213-CFEA-4A37-A3FF-5A3D10E60966',
  res_pdcVanne: 0.0,
  mode: 'none',
  calcul_code: 'I14V2VREGUL'
}

export default I14V2VREGUL
